import $ from 'jquery'

export default {
	init() {

		const $news_slider = $(".news-slider")
		if (!$news_slider.length) return

		$news_slider.slick({
			slidesToShow: 3,
			centerPadding: "40px",
			appendArrows: $(".news-navigation-buttons"),
			prevArrow: $(".news-navigation-buttons .nav-prev"),
			nextArrow: $(".news-navigation-buttons .nav-next"),
			responsive: [
				{
					breakpoint: 1024,
					settings: {
						slidesToShow: 2,
					},
				},
				{
					breakpoint: 768,
					settings: {
						slidesToShow: 1,
					},
				},
			],
		})

	}
}
